<script lang="ts">
	import { getClient, query } from 'svelte-apollo';
	import { onMount } from 'svelte';
	import Fab, { Icon } from '@smui/fab/styled';
	import { Link } from 'svelte-routing';
	import SmuiButton, { Label as SmuiLabel } from '@smui/button/styled';
	import Select from 'svelte-select';
	import { numToRedGreen } from '../../utils';
	import { APP_PATHS } from '../../constants';
	import {
		parseColName,
		csvStringToArrays,
		getTableQuocient,
		roundCellNumber,
		sortValsWithNames,
		sortInterests
	} from './interestsTableUtils';
	import AppContainer from '../../components/AppContainer.svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import Text from '../../components/Text.svelte';
	import GraphErrorList from '../../components/GraphQL/GraphErrorList.svelte';
	import {
		getFileContentInterestsQuery,
		getTrackingPointsQuery
	} from '../../graphql/queries/interests';

	let loading = false;
	let table: any = [],
		age_table: any,
		gender_table: any,
		income_table: any;
	let sortedValues = [];
	let ageValues = [];
	let genderValues = [];
	let incomeValues = [];
	let errorList: string[];
	let selectedInterest: { label: string; value: string };
	let moreHigh = 3;
	let moreLow = 3;
	let trackingsCount = 0;

	let createPersonaData = [];

	const client = getClient();

	const getTrackingPointsOp = query(client, { query: getTrackingPointsQuery });

	function styleValueCell(cellValue: any, all_values: any) {
		all_values = getTableQuocient(all_values);
		const valueIndex = all_values.indexOf(cellValue);

		if (valueIndex >= 0) {
			const color = numToRedGreen(valueIndex / all_values.length, 0.55);
			return `background-color: ${color}`;
		}
	}

	const getFileContentOp = query(client, { query: getFileContentInterestsQuery });

	function parseResponseString(csvString: string) {
		if (csvString.includes('age_groups')) {
			let agesplit = csvString.split('age_groups') as any[];
			table = csvStringToArrays(agesplit[0]);
			age_table = csvStringToArrays(agesplit[1].split('gender_groups')[0]);
			agesplit = agesplit[1].split('gender_groups')[1];
			//@ts-ignore
			gender_table = csvStringToArrays(agesplit);
			//@ts-ignore
			income_table = csvStringToArrays(agesplit.split('income_groups')[1] as any);
		} else {
			table = csvStringToArrays(csvString);
		}
	}

	const getDataFetch = async () => {
		loading = true;
		errorList = undefined;
		try {
			const { data } = await getFileContentOp.refetch();
			console.log(data);
			parseResponseString(data.getInterestContent);
		} catch (error) {
			errorList = error.graphQLErrors;
		}

		loading = false;
	};

	function onSelectChange() {
		const selectedInterestValue = selectedInterest.value;

		sortedValues = sortInterests(table, selectedInterestValue);
		const selectedAgeValues = age_table.find(
			(valsRow: any) => valsRow[0] === `${selectedInterestValue}_age`
		);
		ageValues = sortValsWithNames(age_table[0].slice(1), selectedAgeValues.slice(1));

		if (gender_table) {
			const selectedGenderValues = gender_table.find(
				(valsRow: any) => valsRow[0] === `${selectedInterestValue}_gender`
			);
			genderValues = sortValsWithNames(gender_table[0].slice(1), selectedGenderValues.slice(1));
		}
		if (income_table) {
			const selectedIncomeValues = income_table.find(
				(valsRow: any) => valsRow[0] === `${selectedInterestValue}_income`
			);
			incomeValues = sortValsWithNames(income_table[0].slice(1), selectedIncomeValues.slice(1));
		}

		moreHigh = 3;
		moreLow = 3;
	}

	onMount(() => {
		getDataFetch();
		// parseResponseString(csvInterestsString);
	});

	function MoreClick(event: string) {
		if (event === 'high') {
			moreHigh += 3;
		} else {
			moreLow += 3;
		}
	}

	function reverseArr(input: string[]) {
		var ret = [];
		for (var i = input.length - 1; i >= 0; i--) {
			ret.push(input[i]);
		}
		return ret;
	}

	function AddClick() {
		if (incomeValues.length > 0) {
			if (incomeValues[0].name.includes('high')) {
				createPersonaData.push(['High']);
			} else {
				createPersonaData.push(['Low']);
			}
		} else {
			createPersonaData.push([]);
		}
		if (ageValues.length > 0) {
			if (ageValues[0].name.includes('male')) {
				createPersonaData.push('female');
			} else {
				createPersonaData.push('male');
			}
		} else {
			createPersonaData.push(null);
		}
		if (ageValues.length > 0) {
			createPersonaData.push([
				ageValues[0].name.replace('age(age_', '').replace('-', ' - ').replace(')', '')
			]);
		} else {
			createPersonaData.push([]);
		}
		const myPersona = [
			selectedInterest.value + '-based persona',
			createPersonaData[0],
			createPersonaData[1],
			createPersonaData[2]
		];
		localStorage.setItem('personaData', JSON.stringify(myPersona));
		window.location.href = APP_PATHS.ADD_PERSONA;
	}

	const getCounts = async () => {
		const idRegex = /\((.*?)\)/g;
		const foundlings = selectedInterest.value.match(idRegex);
		const trackingId = foundlings[0].replace(/\(|\)/g, '');
		const { data } = await getTrackingPointsOp.refetch();
		const certainTargets = data.trackings
			.filter((target: any) => {
				return parseInt(target.tpId) === parseInt(trackingId);
			})
			.sort(function (a: any, b: any) {
				return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
			});
		if (certainTargets.length > 0) {
			trackingsCount = certainTargets[0].tpCount;
		} else {
			trackingsCount = 0;
		}
	};

	$: if (typeof selectedInterest !== 'undefined') {
		getCounts();
	}

	$: selectItems = table
		.slice(1)
		.map((val: any) => ({ label: val[0].replace(/\(.+\)/g, ''), value: val[0] }));
</script>

<AppContainer style="position:relative;">
	{#if loading}
		<LoadingOverlay title="Loading..." spinner />
	{/if}
	{#if table}
		<Text type="headline4">Please select Key Interaction</Text>
		<div class="flex">
			<div style="width: 150px; margin-left: 15px;">
				<Select
					selectedValue={selectedInterest}
					items={selectItems}
					on:select={(e) => {
						selectedInterest = e.detail;
						onSelectChange();
					}}
				/>
			</div>
			<div class="button-add">
				<Link to={APP_PATHS.LINKIFY}>
					<Fab color="primary">
						<Icon class="material-icons">add</Icon>
					</Fab>
				</Link>
			</div>
			{#if trackingsCount > 0}
				<div class="count-wrap">
					Tracking point count: <strong>{trackingsCount.toLocaleString()}</strong>
				</div>
			{/if}
		</div>
	{/if}
	{#if sortedValues.length}
		<div class="flex responsive last">
			<div class="left">
				<Text type="headline5">High Affinity Interests</Text>
				<br />
				<table>
					<tbody>
						{#each sortedValues.filter((name, idx) => name && idx < moreHigh) as valWName}
							{#if valWName.value >= 0}
								<tr>
									<td>{parseColName(valWName.name)}</td>
									<td style={styleValueCell(valWName.value, table)}
										>{roundCellNumber(valWName.value)}</td
									>
								</tr>
							{/if}
						{/each}
						{#if sortedValues.filter((name) => name.value >= 0).length > moreHigh}
							<div class="more-button">
								<SmuiButton on:click={() => MoreClick('high')} variant="raised">
									<SmuiLabel>More</SmuiLabel>
								</SmuiButton>
							</div>
						{/if}
					</tbody>
				</table>
			</div>
			<div class="right">
				<Text type="headline5">Low Affinity Interests</Text>
				<br />
				<table>
					<tbody>
						{#each reverseArr(sortedValues).filter((name, idx) => name !== null && idx < moreLow) as valWName}
							{#if valWName.value <= 0}
								<tr>
									<td>{parseColName(valWName.name)}</td>
									<td style={styleValueCell(valWName.value, table)}
										>{roundCellNumber(valWName.value)}</td
									>
								</tr>
							{/if}
						{/each}
						{#if sortedValues.filter((name) => name.value <= 0).length > moreLow}
							<div class="more-button">
								<SmuiButton on:click={MoreClick} variant="raised">
									<SmuiLabel>More</SmuiLabel>
								</SmuiButton>
							</div>
						{/if}
					</tbody>
				</table>
			</div>
		</div>
		<div class="flex responsive last">
			<div class="left">
				<Text type="headline5">Age Affinity</Text>
				<br />
				<table>
					<tbody>
						{#each ageValues.filter((name, idx) => name !== null && idx < ageValues.length) as valWName}
							<tr>
								<td>{parseColName(valWName.name)}</td>
								<td style={styleValueCell(valWName.value, age_table)}
									>{roundCellNumber(valWName.value)}</td
								>
							</tr>
						{/each}
					</tbody>
				</table>
			</div>
			<div class="right">
				<Text type="headline5">Gender Affinity</Text>
				<br />
				<table>
					<tbody>
						{#each genderValues.filter((name, idx) => name !== null && idx < genderValues.length) as valWName}
							<tr>
								<td>{parseColName(valWName.name)}</td>
								<td style={styleValueCell(valWName.value, gender_table)}
									>{roundCellNumber(valWName.value)}</td
								>
							</tr>
						{/each}
					</tbody>
				</table>
			</div>
			{#if incomeValues.length > 0}
				<div class="right">
					<Text type="headline5">Income</Text>
					<br />
					<table>
						<tbody>
							{#each incomeValues.filter((name, idx) => name !== null && idx < incomeValues.length) as valWName}
								<tr>
									<td>{parseColName(valWName.name)}</td>
									<td style={styleValueCell(valWName.value, income_table)}
										>{roundCellNumber(valWName.value)}</td
									>
								</tr>
							{/each}
						</tbody>
					</table>
				</div>
			{/if}
		</div>
		<SmuiButton on:click={AddClick} variant="raised">
			<SmuiLabel>Create persona</SmuiLabel>
		</SmuiButton>
	{/if}

	<GraphErrorList {errorList}>
		<p>Data not available for client</p>
	</GraphErrorList>
</AppContainer>

<style>
	table {
		border-spacing: 0;
	}

	td {
		border-bottom: 1px solid #999;
		border-right: 1px solid hsla(0, 0%, 100%, 0.67);
		min-width: 40px;
	}

	td:first-of-type {
		min-width: 200px;
		width: 200px;
		padding-left: 8px;
		line-height: 1;
	}
	td:nth-of-type(n + 2) {
		text-align: right;
		padding: 14px 10px;
	}

	tbody tr:hover {
		background-color: #00000020;
	}
	.button-add {
		margin-left: 24px;
	}

	.flex {
		display: flex;
		flex-direction: row;
		margin-top: 24px;
		align-items: center;
	}

	.flex.responsive {
		flex-direction: column;
	}

	@media screen and (min-width: 600px) {
		.flex.responsive {
			flex-direction: row;
		}
	}
	.left,
	.right {
		padding: 12px 24px 12px 0;
	}
	.more-button {
		padding-top: 20px;
		display: flex;
		align-items: center;
	}

	.count-wrap {
		margin-left: 20px;
	}

	.flex.last {
		align-items: flex-start;
	}

	:global(.select-fixed-width) {
		width: 150px;
	}
</style>
